/* ── WORK_TRACK — Daily effort chart mount ───────────────────
   Mounts the React glass daily-effort chart into #effortCard on
   the dashboard. */

import { createRoot } from 'react-dom/client';
import { $ } from '@/core';
import { DailyEffortChart } from '@/components/ui/daily-effort-chart';

let mounted = false;

export function mountEffortChart(): void {
  if (mounted) return;
  const rootEl = $('#effortCard');
  if (!rootEl) return;
  mounted = true;
  createRoot(rootEl).render(<DailyEffortChart />);
}